import React from "react";
import { ColorPicker } from "Source/globalComponents";

class Color extends React.Component {
    render() {
        return (
            <ColorPicker 
                onSelect={this.props.onChangeColor} 
                color={this.props.color} 
                placeholder={"Search"} 
                required={true} 
            />
        );
    }
}

export default Color;
